import errorCodes from '../data/error-codes.json'

export default {
  methods: {
    getErrorMsg: function (error, fallback) {
      const fallbackMsg = fallback || 'Whoops... something went wrong with your request. Please refresh and try again.'

      if (error.response &&
      error.response.data &&
      error.response.data.error_code &&
      errorCodes[error.response.data.error_code]) {
        const errorCodeStr = error.response.data.error_code.toString()
        return errorCodes[errorCodeStr].message || fallbackMsg
      } else {
        return fallbackMsg
      }
    },
    isInvalidMFALoginTokenError: function (error) {
      if (error.response &&
        error.response.data &&
        error.response.data.error_code &&
        (error.response.data.error_code === 76210 || error.response.data.error_code === 76216)) {
        return true
      } else {
        return false
      }
    },
    isInvalidMFAAuthTokenError: function (error) {
      if (error.response &&
        error.response.data &&
        error.response.data.error_code &&
        error.response.data.error_code === 76201) {
        return true
      } else {
        return false
      }
    }
  }
}
